import React, { useId } from "react";

import { Toggle } from "../../components/ui";

// Lookbook / request-page labelled switch. The visible <label> and the wrapper
// classes stay (layout CSS targets `.switch` / `.lookbook-toggle label`); the
// switch itself is ui/Toggle. onChange(next: boolean), as react-switch called it.
export function ToggleButton({
  label,
  checked,
  onChange,
  center = false,
  disabled = false,
  fullWidth = false,
}) {
  const id = useId();
  const layoutClass = fullWidth
    ? "justify-content-between"
    : `justify-content-${center ? "center" : "end"}`;

  return (
    <div className={`switch d-flex ${layoutClass} lookbook-toggle`}>
      <label className="align-self-center" htmlFor={id}>{label}</label>

      <Toggle
        id={id}
        checked={!!checked}
        onChange={onChange}
        disabled={disabled}
        // Sortable lookbook rows: flipping must not start a drag.
        onPointerDown={(e) => e.stopPropagation()}
      />
    </div>
  );
}
